import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';

/**
 * DELETE /api/eraf/retention-admin/policies/{id} — 보존 정책 삭제 (RETENTION_MANAGE)
 */
export function useDeletePolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => retentionAdminApi.deletePolicy(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'list'] });
    },
  });
}
